import { render, staticRenderFns } from "./FestivalNav.vue?vue&type=template&id=a8bb13ca&scoped=true"
import script from "./FestivalNav.vue?vue&type=script&lang=js"
export * from "./FestivalNav.vue?vue&type=script&lang=js"
import style0 from "./FestivalNav.vue?vue&type=style&index=0&id=a8bb13ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bb13ca",
  null
  
)

export default component.exports